export const MAX_LEVEL = 30;

/** XP needed to go from `level` to `level + 1`. */
export function xpToNextLevel(level: number): number {
  return Math.round(20 * Math.pow(level, 1.6));
}

/** Total XP required to reach `level` (level 1 needs 0). */
export function totalXpForLevel(level: number): number {
  let total = 0;
  for (let l = 1; l < level; l++) total += xpToNextLevel(l);
  return total;
}

export function levelFromXp(xp: number): number {
  let level = 1;
  let remaining = xp;
  while (level < MAX_LEVEL && remaining >= xpToNextLevel(level)) {
    remaining -= xpToNextLevel(level);
    level++;
  }
  return level;
}

export interface LevelProgress {
  level: number;
  /** XP earned towards the next level. */
  current: number;
  /** XP needed for the next level (0 at max level). */
  needed: number;
  fraction: number;
}

export function levelProgress(xp: number): LevelProgress {
  const level = levelFromXp(xp);
  if (level >= MAX_LEVEL) return { level, current: 0, needed: 0, fraction: 1 };
  const current = xp - totalXpForLevel(level);
  const needed = xpToNextLevel(level);
  return { level, current, needed, fraction: current / needed };
}
